import { isFeatureEnabled } from "config/features"
import i18n from "i18n"

/**
 * Returns step metadata for the new wizard UI.
 * Called at runtime so feature flags are evaluated fresh.
 */
export const getStepConfig = () => [
  {
    id: "details",
    label: i18n.t("listings.tabs.details.label"),
    title: i18n.t("listings.tabs.details.title"),
    percent: 0
  },
  {
    id: "scheduling",
    label: i18n.t("listings.tabs.scheduling.label"),
    title: i18n.t("listings.tabs.scheduling.title"),
    percent: 30
  },
  {
    id: "media",
    label: i18n.t("listings.tabs.media.label"),
    title: i18n.t("listings.tabs.media.title"),
    subTitle: i18n.t("listings.tabs.media.subtitle"),
    percent: 45
  },
  {
    id: "resources",
    label: i18n.t("listings.tabs.resources.label"),
    percent: 65
  },
  {
    id: "location",
    label: i18n.t("listings.tabs.location.label"),
    title: i18n.t("listings.tabs.location.title"),
    subTitle: i18n.t("listings.tabs.location.subtitle"),
    percent: 85
  },
  ...(isFeatureEnabled("CUSTOM_TEMPLATE")
    ? [
        {
          id: "digital_waiver",
          label: i18n.t("listings.tabs.digital_waiver.label"),
          title: i18n.t("listings.tabs.digital_waiver.title"),
          percent: 90
        }
      ]
    : []),
  {
    id: "preview",
    label: i18n.t("listings.tabs.preview.label"),
    title: i18n.t("listings.tabs.preview.title"),
    subTitle: i18n.t("listings.tabs.preview.subtitle"),
    percent: 95
  }
]
